import { render, staticRenderFns } from "./CustomConfigMode.vue?vue&type=template&id=cbd87eb0"
import script from "./CustomConfigMode.vue?vue&type=script&lang=js"
export * from "./CustomConfigMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports